
export default {
  props: {
    title: {
      type: String,
      default: "Continue"
    }
  }
};
